module.exports = __webpack_public_path__ + "static/img/right.11b016c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/right.png
// module id = xWId
// module chunks = 0